import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { withoutObjectKeysWhereValueIs } from '@vestigas/utils';

import {
  type SupplierHistoryQueryParams,
  type SupplierHistoryResponse,
} from './types';
import {
  zodSupplierHistoryQueryParamsSchema,
  zodSupplierHistoryResponseSchema,
} from './validations';

/**
 * Fetches the change history for a supplier relationship.
 *
 * @param deId - The data exchange ID of the supplier relationship.
 * @param queryParams - Optional pagination parameters (page, pageSize).
 * @param options - Optional ky request options (e.g., abort signal).
 * @returns The paginated supplier history response.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Supplier-details/operation/get_supplier_history_suppliers_details__de_id__history_get
 */
export const fetchSupplierHistory = async (
  deId: UUID,
  queryParams: SupplierHistoryQueryParams = {},
  options?: KyRequestOptions,
) =>
  vestigasApi
    .get(ENDPOINT.SUPPLIER.GET_HISTORY(deId), {
      ...options,
      searchParams: queryParams,
      validate: {
        ...options?.validate,
        response: zodSupplierHistoryResponseSchema,
        searchParams: zodSupplierHistoryQueryParamsSchema.transform((value) =>
          withoutObjectKeysWhereValueIs(value, [null, undefined]),
        ),
      },
    })
    .json<SupplierHistoryResponse>();
